export default "__VITE_ASSET__DJnhtfr3__"